export default __webpack_public_path__ + "static/media/marketing.d0420d63.svg";